import { api } from "@/lib/api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
};

export const pushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export const ensureServiceWorker = async () => {
  if (!pushSupported()) return null;
  // Avoid double-registering
  const existing = await navigator.serviceWorker.getRegistration("/sw.js");
  if (existing) return existing;
  return navigator.serviceWorker.register("/sw.js");
};

export const getCurrentPushSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await ensureServiceWorker();
  if (!reg) return null;
  return (await reg.pushManager.getSubscription()) || null;
};

export const subscribeToPush = async () => {
  if (!pushSupported()) {
    throw new Error("Push notifications are not supported in this browser");
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission denied");

  const reg = await ensureServiceWorker();
  if (!reg) throw new Error("Service worker registration failed");

  const { data } = await api.get("/notifications/vapid-public-key");
  const key = data?.publicKey;
  if (!key) throw new Error("Server is missing VAPID configuration");

  // Already subscribed? Reuse.
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(key),
    });
  }
  await api.post("/notifications/subscribe", sub.toJSON());
  return sub;
};

export const unsubscribeFromPush = async () => {
  const sub = await getCurrentPushSubscription();
  if (!sub) return;
  try {
    await api.post("/notifications/unsubscribe", { endpoint: sub.endpoint });
  } catch { /* ignore server-side cleanup failure */ }
  await sub.unsubscribe();
};
